import React, { useEffect, useState } from 'react';
import { QuickPayLayout } from '../components/portal/quick-pay/QuickPayLayout';
import { AccountDashboard } from '../components/portal/login-pay/AccountDashboard';
import { ConfirmAndDone } from '../components/portal/quick-pay/ConfirmAndDone';
import type { PaymentData } from '../components/portal/quick-pay/BalanceAndPay';
import { ReferenceModal } from '../components/portal/quick-pay/ReferenceModal';
import { useScreenInit } from '../useScreenInit';
type Stage = 'enter' | 'dashboard' | 'confirm';
function generateConfirmationNumber() {
  return 'CRG-' + Math.random().toString(36).slice(2, 6).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
}
function stepForStage(stage: Stage): 1 | 2 | 3 {
  if (stage === 'enter') return 1;
  if (stage === 'dashboard') return 2;
  return 3;
}
export function QuickPayFlow() {
  const seed = useScreenInit() as {
    stage?: Stage;
    reference?: string;
    amount?: number;
    paymentData?: PaymentData;
    isConfirmed?: boolean;
    confirmationNumber?: string;
  } | undefined;
  const [stage, setStage] = useState<Stage>(seed?.stage ?? 'enter');
  const [reference, setReference] = useState(seed?.reference ?? '');
  const [, setAmount] = useState<number>(seed?.amount ?? 0);
  const [paymentData, setPaymentData] = useState<PaymentData | null>(seed?.paymentData ?? null);
  const [isConfirmed, setIsConfirmed] = useState(seed?.isConfirmed ?? false);
  const [confirmationNumber, setConfirmationNumber] = useState(seed?.confirmationNumber ?? '');
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [stage, isConfirmed]);
  const goBack = () => {
    if (stage === 'dashboard') setStage('enter');else if (stage === 'confirm') setStage('dashboard');
  };
  return <>
      <QuickPayLayout currentStep={stepForStage(stage)} showSuccess={isConfirmed} onBack={stage !== 'enter' && !isConfirmed ? goBack : undefined} wide={stage === 'dashboard' || stage === 'enter'} data-id="element-1459">
        {(stage === 'enter' || stage === 'dashboard') && <AccountDashboard email={reference || 'Guest'} onContinue={data => {
        setPaymentData(data);
        setStage('confirm');
      }} data-id="element-1460" />}
        {stage === 'confirm' && paymentData && <ConfirmAndDone paymentData={paymentData} isConfirmed={isConfirmed} confirmationNumber={confirmationNumber} onConfirm={() => {
        setConfirmationNumber(generateConfirmationNumber());
        setIsConfirmed(true);
      }} data-id="element-1461" />}
      </QuickPayLayout>

      {stage === 'enter' && <ReferenceModal onSubmit={(ref, amt) => {
      setReference(ref);
      setAmount(amt);
      setStage('dashboard');
    }} data-id="element-1462" />}
    </>;
}